import { ChangeEventHandler, CSSProperties, FocusEventHandler, ReactElement } from 'react';
import { cn } from '@bridebook/aura';

interface Props {
  value?: string;
  placeholder?: string;
  name?: string;
  dataTest?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  label?: string;
  /** Extra wrapper classes, e.g. height and corner radius per usage. */
  className?: string;
  /** Inline wrapper overrides (used for a fixed pixel height). */
  style?: CSSProperties;
  beforeInput?: ReactElement;
  afterInput?: ReactElement;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
}

/**
 * Text input for the location autocomplete, styled with Tailwind.
 */
export const AutocompleteTextInput = ({
  value,
  placeholder,
  name,
  dataTest,
  disabled,
  autoFocus,
  label,
  className,
  style,
  beforeInput,
  afterInput,
  onChange,
  onFocus,
  onBlur,
}: Props) => (
  <div className={cn('bsauto', disabled && 'bsauto-disabled', className)} style={style}>
    <div className="bsauto-inner">
      {label && <span className="bsauto-label">{label}</span>}
      <div className="bsauto-field">
        {beforeInput}
        <input
          name={name}
          data-test={dataTest}
          className="bsauto-input"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          autoFocus={autoFocus}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
    </div>
    {afterInput}
  </div>
);
